import { Phone } from "lucide-react";
import { NAP, BOOKING_URL } from "../lib/config";

export default function BookCallCTA({ title = "Book direct. Talk to a real person. Sleep well.", eyebrow = "Ready when you are", dark = false }) {
  return (
    <section className={dark ? "bg-[#E85D26] text-white" : "bg-[#1A1A1A] text-white"} data-testid="book-call-cta">
      <div className="wb-container py-14 md:py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className={`text-xs sm:text-sm font-black uppercase tracking-[0.18em] ${dark ? "text-white/85" : "text-[#FF9666]"}`} style={{ fontFamily: "'Nunito', sans-serif" }}>
            {eyebrow}
          </div>
          <h2 className="wb-h2 text-white mt-3 max-w-xl">{title}</h2>
        </div>
        <div className="flex flex-wrap gap-3">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={dark ? "inline-flex items-center gap-2 bg-white text-[#B94A15] font-bold py-3 px-6 rounded-sm hover:bg-[#FDFBF7]" : "wb-btn-primary"}
            style={{ fontFamily: "'Nunito', sans-serif" }}
            data-testid="book-call-cta-book"
          >
            Book Now
          </a>
          <a
            href={`tel:${NAP.phoneTel}`}
            className="inline-flex items-center gap-2 border-2 border-white text-white font-bold py-3 px-6 rounded-sm hover:bg-white hover:text-[#1A1A1A]"
            style={{ fontFamily: "'Nunito', sans-serif" }}
            data-testid="book-call-cta-call"
          >
            <Phone className="h-4 w-4" /> {NAP.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
